<template>
<div class="chapter">
<div class="inner_page">
<h1 class="center" id="chap1"><a id="start"><i>At North Farm</i></a></h1><a id="start">
<p class="poem1">Somewhere someone is traveling furiously toward you,</p>
<p class="poem1">At incredible speed, traveling day and night,</p>
<p class="poem1">Through blizzards and desert heat, across torrents, through narrow passes.</p>
<p class="poem1">But will he know where to find you,</p>
<p class="poem1">Recognize you when he sees you,</p>
<p class="poem1">Give you the thing he has for you?</p>
<p class="poem1" style="margin-top:20px;">Hardly anything grows here,</p>
<p class="poem1">Yet the granaries are bursting with meal,</p>
<p class="poem1">The sacks of meal piled to the rafters.</p>
<p class="poem1">The streams run with sweetness, fattening fish;</p>
<p class="poem1">Birds darken the sky. Is it enough</p>
<p class="poem1">That the dish of milk is set out at night,</p>
<p class="poem1">That we think of him sometimes,</p>
<p class="poem1">Sometimes and always, with mixed feelings?</p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 5chap1.vue?61c48e2e